import { useState } from "react";
import { useSelector } from "react-redux";
import { SITE_COLUMNS } from "../../utils/siteTables.config";
import MobileActionHeader from "../../../../components/UI/headingsUI/MobileActionHeader";
import FilterSearch from "../../../../components/common/FilterSearch";
import { filterCategorySite } from "../../../../utils/filterCategoryList";
import { siteSearch } from "../../../../utils/tableSearchList";
import SiteViewDialog from "../../dialog/SiteViewDialog";
import UsePermissionsClaim from "../../../../CustomHooks/UsePermissionsClaim";
import { filterTableColumns } from "../../../../utils/tableHeaderConfigh";
import { adminRoles } from "../../../../utils/adminRoles";
import SiteTableView from "./SiteTableView";
import { formatSiteExcelData } from "../../utils/excelFormatters";

const SiteList = ({ sitesData }) => {
  const [viewDialogDetails, setViewDialogDetails] = useState({});
  const originalSitesData = useSelector((state) => state.data.copyData);
  const { checkPermission } = UsePermissionsClaim();
  const permAddSite = checkPermission("add_site");
  const permAddOperator = checkPermission("add_station_operator");
  const filteredHeadList = filterTableColumns({
    headList: SITE_COLUMNS,
    removeIfNoPermission: [
      {
        key: "Action",
        condition: permAddSite || permAddOperator,
      },
    ],
    roleConfig: {
      Supervisor: adminRoles,
    },
  });

  // ...............get  excel data............
  const excelData = formatSiteExcelData(originalSitesData);
  const excelConfig = {
    data: excelData,
    fileName: "Sites_Data",
    sheetName: "Sites",
  };

  return (
    <>
      <MobileActionHeader
        title="Sites"
        navigate={"/site/add"}
        btnText={permAddSite ? "Add Site" : undefined}
      />
      <FilterSearch
        categories={filterCategorySite}
        searchCategories={siteSearch}
        addBtnNavigation={"/site/add"}
        addBtnText={permAddSite ? "Add Site" : undefined}
        excelConfig={excelConfig}
      />
      <SiteTableView
        setViewDialogDetails={setViewDialogDetails}
        filteredHeadList={filteredHeadList}
      />
      {viewDialogDetails?.open && (
        <SiteViewDialog
          closeDialog={() => setViewDialogDetails({})}
          viewDetails={viewDialogDetails.data}
          setViewDialogDetails={setViewDialogDetails}
        />
      )}
    </>
  );
};
export default SiteList;
